import React, { useContext, useEffect } from 'react';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import { DeclaredComponent } from '../../DynamicComponent';
import { GlobalStateContext } from '../../../context/GlobalStateProvider';
import { Divider } from 'antd';
import { Expression } from '../../metadata/Expression';
import { ModelContext } from '../../metadata/ModelSource';
import { MDForm } from '../../metadata/MDForm';
import { ProductInfoContext } from '../../data/ApplicationDataSource';

const defaultColSpans = [8,6,6,4]

const Label = ({ labels, currentIndex }) => {
  return (
      <Col span={12} className={'label'} >
        <DeclaredComponent declaration={labels[currentIndex]} />
      </Col>
  );
};

const MobileTable = ({ tableData, currentIndex, labels, prefix }) => {

  return (
    <div className={'coverage-detail-row'}>
      {tableData.content.map((item, index) => {
        const currentIndex = index;
        return (
          <Row key={index}>
              <>
                <Label labels={labels} currentIndex={currentIndex} />
                <Col
                  span={12}
                  className={'field'}
                  key={index}
                >
                  <DeclaredComponent declaration={item} prefix={prefix} />
                </Col>
              </>
          </Row>
        );
      })}
    </div>
  );
};

const RowData = ({tableData, colSpans}) => {
  const lastIndex = tableData.content.length - 1;
    return tableData.content.map((item, index) => (
        <Col
          key={index}
          span={colSpans[index]}
        >
          <DeclaredComponent declaration={item} style={{fontWeight: index === lastIndex ? 'bold': 'normal'}} />
        </Col>
    ));
};

const DesktopTable = ({ tableData, prefix, colSpans }) => {

  return (
    <Row>
      <RowData tableData={tableData} prefix={prefix} colSpans={colSpans}/>
    </Row>
  );
};

const Labels = ({labels, colSpans}) => {
  const lastIndex = labels.length - 1;
  return labels.map((label, index) => (
      <Col
        span={colSpans[index]}
        key={index}
        className={'label'}
      >
        <DeclaredComponent declaration={label} />
      </Col>
  ));
};

const DesktopHeader = ({ isDesktop, labels, colSpans }) => {
  if (!isDesktop) return null;

  return (
    <Row>
      <div>
        <Labels labels={labels} colSpans={colSpans}/>
      </div>
      <Divider />
    </Row>
  );
};

const Table = ({ isDesktop, tableData, index, labels, colSpans, prefix }) => {
  if (isDesktop) {
    return (
        <div>
          <DesktopTable
              tableData={tableData}
              key={index}
              prefix={prefix}
              colSpans={colSpans}
          />
        </div>
    );
  }
  return (
        <MobileTable
            labels={labels}
            tableData={tableData}
            currentIndex={index}
            key={index}
            prefix={prefix}
        />
  );
};

export const CoverageTable = ({ content, labels, colSpans, prefix, ...props }) => {
  if (!content) return null;
  colSpans = colSpans || defaultColSpans;
  const { isDesktop } = useContext(GlobalStateContext);
  const { productSetup } = useContext(ProductInfoContext);
  const model = useContext(ModelContext);

  return (
    <div className={isDesktop ? 'coverage-table desktop' : 'coverage-table mobile'}>
      <DesktopHeader isDesktop={isDesktop} colSpans={colSpans} labels={labels} />
      {content &&
        content.map((data, index) => {
          const { tableData, additionalCoverages } = data;
          // Return table with coverages that are changeable
          if (tableData !== undefined && additionalCoverages === undefined) {
            return <Table isDesktop={isDesktop} tableData={tableData} key={index} index={index} labels={labels} colSpans={colSpans} prefix={prefix}/>;
          }

          // Return table with additional coverages that cannot be changed by user
          const model = useContext(ModelContext);
          const homeOWPrefix = 'risk[0].building'
          const PAPrefix = prefix + 'coverages'
          const prefixToUse = prefix ? PAPrefix : homeOWPrefix
          const allAvailableCoverages = model.getValue(prefixToUse);

          const coveragesToSkip = [
            'BI',
            'PD',
            'MedPay',
            'UMBI',
            'UIMBI',
            'Comprehensive',
            'Collision',
            'WaiverOfCollision',
          ];
          if (!coveragesToMap) return null;
          const coveragesToMap = allAvailableCoverages.filter(
            (currentCoverage) => {
              if (coveragesToSkip.includes(currentCoverage.coverageCd)) {
                return;
              } else {
                return currentCoverage;
              }
            }
          );

          // if (!coveragesToMap) return null;

          return (
            <div style={{ marginTop: '-8px' }}>
              {coveragesToMap.map((data, index) => {
                const tableData = [
                  {
                    row: [
                      {
                        Expression: {
                          style: {
                            fontWeight: 'bold',
                            paddingTop: 4,
                          },
                          value: data.description,
                        },
                      },
                    ],
                  },
                  {
                    row: [
                      {
                        Expression: {
                          value: '',
                        },
                      },
                    ],
                  },
                  {
                    row: [
                      {
                        MoneyAmount: {
                          style: {
                            fontWeight: 'bold',
                          },
                          value: data.writtenPremiumAmt,
                        },
                      },
                    ],
                  },
                ];

                return <Table tableData={tableData} index={index} />;
              })}
            </div>
          );
        })}
    </div>
  );
};
